import Dynamicore, { SERVICES } from '../index';
import { withRetries } from 'utils/withRetries';

async function getUserInfo() {
  try {
    const args = [...arguments];
    const { values: info } = await withRetries(() => Dynamicore(SERVICES.USERS_GET_INFO).get());
    
    const key = `dcore:${info?.company}:client:`;
    const peopleId = String((info?.json_rol?.Statement ?? [])
      .find((item) => item.Resource.startsWith(key))?.Resource ?? '')
      .replace(key, '');
    const accountKey = `dcore:${info?.company}:account:`;
    const accountIds = (info?.json_rol?.Statement ?? [])
      .filter((item) => item.Resource.startsWith(accountKey))
      .map((item) => item.Resource.split(':').pop());
    
    const user = {
      id: info.user,
      data: args.length > 0 ? {} : undefined,
      entities: {
        accountIds: accountIds,
        companyId: info.company,
        groupId: info.group,
        peopleId: parseInt(peopleId),
      },
    };

    if (args.includes('company')) {
      try {
        user.data.company = await withRetries(() => Dynamicore(SERVICES.COMPANY).get({
          id: user?.entities?.companyId,
        }));
      } catch (error) {
        console.error('Error fetching company data after retries:', error);
        user.data.company = null;
      }
    }

    if (args.includes('people')) {
      try {
        user.data.people = await withRetries(() => Dynamicore(SERVICES.PEOPLE).get({
          id: user?.entities?.peopleId,
        }));

        user.data.peopleType = await withRetries(() => Dynamicore(SERVICES.PEOPLE_TYPES).get({
          id: user?.data?.people?.client_type ?? 0,
        }));

        user.entities.peopleTypeId = user?.data?.peopleType?.id;
      } catch (error) {
        console.error('Error fetching people data after retries:', error);
        user.data.people = null;
        user.data.peopleType = null;
      }
    }

    if (args.includes('relationships')) {
      try {
        const { values: relationships = [] } = await withRetries(() => 
          Dynamicore(SERVICES.PEOPLE_ORGANIZATIONAL_OLD).get({
            borrower: user?.entities?.peopleId,
          }),
        );
        
        const { values: relatedPeople = [] } = await withRetries(() => 
          Dynamicore(SERVICES.PEOPLE_ORGANIZATIONAL).get({
            borrower: user?.entities?.peopleId,
            limit: 1000,
            page: 1,
          }),
        );

        relationships.forEach((item) => {
          item.people = relatedPeople
            .find((relatedItem) => relatedItem.id === item.person);
          delete item.person;
        });

        user.data.relationships = relationships;
      } catch (error) {
        console.error('Error fetching relationships data after retries:', error);
        user.data.relationships = [];
      }
    }

    return user;
  } catch (error) {
    console.error('Error in getUserInfo:', error);
    throw error;
  }
};

export default getUserInfo;
